import { render, staticRenderFns } from "./calidad.vue?vue&type=template&id=38d2f035"
import script from "./calidad.vue?vue&type=script&lang=js"
export * from "./calidad.vue?vue&type=script&lang=js"
import style0 from "./calidad.vue?vue&type=style&index=0&id=38d2f035&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports